let tickerSpeed3 = 0;

let flickity3 = null;
let isPaused3 = true;
const slideshowE3 = document.querySelector('.collections-slideshow');

const update3 = () => {
  if (isPaused3) return;
  if (flickity3.slides) {
    flickity3.x = (flickity3.x - tickerSpeed3) % flickity3.slideableWidth;
    flickity3.selectedIndex = flickity3.dragEndRestingSelect();
    flickity3.updateSelectedSlide();
    flickity3.settle(flickity3.x);
  }
  window.requestAnimationFrame(update3);
};

const pause3 = () => {
  isPaused3 = true;
};

const play3 = () => {
  if (isPaused3) {
    isPaused3 = false;
    window.requestAnimationFrame(update3);
  }
};

flickity3 = new Flickity(slideshowE3, {
  autoPlay: false,
  prevNextButtons: false,
  pageDots: false,
  draggable: true,
  wrapAround: false,
  cellAlign: 'center',
  contain: true,      
  freeScroll: true,  
  selectedAttraction: 0.015,
  friction: 0.25 });

flickity3.x = 0;

update3();